import React from "react";

import styles from "./SettingsWrapper.css";

export default function SettingsWrapper({ children }) {
  return <div className={styles.root}>{children}</div>;
}
